import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { ActiveInactiveFor, KeyValues3, LocalService, Paging, StatusWithId, Wrappers15, KeyValueSet, QrGenerateRequest, KeyValues10, PaymentGatewayServiceType, KeyValues5, StatusKeyValues5 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class QrPaymentService {
  private controllerName = service_controllers_methods.qrPayment.controller;
  private methods = service_controllers_methods.qrPayment.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  getQrPaymentLogs(businessId: string, paging?: Paging): Observable<Wrappers15> {
    let body = {
      sel: this.localService.getSelected(),
      pag: paging,
      dt: { v1: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetQrPaymentLogs, body);
  }

  getQrPaymentTitles(businessId: string): Observable<KeyValueSet[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetQrPaymentTitles, body);
  }

  generateQrCode(request: QrGenerateRequest): Observable<StatusKeyValues5> {
    let body = {
      sel: this.localService.getSelected(),
      request: request
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GenerateQrCode, body);
  }

  saveQrPaymentConfig(data: KeyValues10): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveQrPaymentConfig, body);
  }

  getQrPaymentConfigs(countryCode: string, businessId: string, gatewayType: PaymentGatewayServiceType): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: countryCode, v2: businessId, v3: gatewayType.toString() } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetQrPaymentConfigs, body);
  }

  getQrPaymentConfig(countryCode: string, businessId: string, gatewayType: PaymentGatewayServiceType, id?: string): Observable<KeyValues10> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: id, v1: countryCode, v2: businessId, v3: gatewayType.toString() } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetQrPaymentConfig, body);
  }

  activeInactiveStatus(strId: string, actionFor: ActiveInactiveFor): Observable<StatusWithId> {
    let body = {
      strId: strId,
      sel: this.localService.getSelected(),
      iActionFor: parseInt(actionFor.toString())
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ActiveInactiveStatus, body);
  }

  getConfiguredPaymentGateways(countryCode: string, businessId: string): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: countryCode, v2: businessId } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetConfiguredPaymentGateways, body);
  }

  updateBusinessPrimaryPaymentGateway(countryCode: string, businessId: string, gatewayType: PaymentGatewayServiceType): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: countryCode, v2: businessId, v3: gatewayType.toString() } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateBusinessPrimaryPaymentGateway, body);
  }

  getQrPaymentLogStatusById(processId: string,): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: processId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetQrPaymentLogStatusById, body);
  }
}
